import React, { useLayoutEffect } from 'react';
import { NavMenu } from './NavMenu';
import Announcement from './announcement';
import Footer from './Footer';
import { useLocation } from 'react-router-dom'

const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children
}

export const Layout = ({ children }) => {

  const location = useLocation();
  var isIndex = location.pathname === '/' ? true : false;

  return (
    <Wrapper>
      <div>
        <NavMenu isIndex={isIndex} pathname={location.pathname} />
        {isIndex && <Announcement />}
        <div>
          {children}
        </div>
        <Footer />
      </div>
    </Wrapper>
  );
}
